import { extra } from '@/theme/colors/palettes';
import { VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

const SectionContainer = ({ children }: PropsWithChildren) => {
  return (
    <VStack
      style={{
        width: '100%',
        background: extra.white,
        padding: '24px 40px',
        boxShadow: '0px 8px 40px 0px #0041790D',
        borderRadius: 12,
        alignItems: 'start',
      }}
    >
      {children}
    </VStack>
  );
};

export default SectionContainer;
